import { composeIO } from 'react-compose-io'
import { modalVisualizarAssociacaoIO } from './ModalVisualizarAssociacao.IO'
import { ModalVisualizarAssociacaoView } from './ModalVisualizarAssociacao.View'

export const ModalVisualizarAssociacao = composeIO(ModalVisualizarAssociacaoView, modalVisualizarAssociacaoIO)
